import { actionTypes } from './constants';

export const repositoryPagesActionTypes = {
  setFetching: actionTypes.REPOSITORY_PAGES_SET_FETCHING,
};
